export interface VoxnelaStyleItem {
  id: string
  rank: number
  title: string
  badge: string
  description: string
  samplePrompt?: string
  realPrompt: string
  suggestions?: [string, string]
  imageUrl: string
  aspectRatio: '9:16'
}

export const VOXNELA_50_STYLES: VoxnelaStyleItem[] = [
  {
    "id": "reality-warp",
    "rank": 1,
    "title": "Reality Warp / Digital Hallucination",
    "badge": "Rüya Portre",
    "description": "Fotoğrafını rüya benzeri, fizik kurallarını aşan sürrealist bir boyuta taşır; süzülen heykelsi mimari ve uncanny atmosfer.",
    "samplePrompt": "Beni yerçekimsiz süzülen fütüristik bir rüya mimarisinde göster",
    "realPrompt": "Reality warp fine art photography and surreal portrait. A charismatic subject seamlessly immersed in a reality-warp dreamscape with physically impossible floating architectural monoliths, warped perspective horizons, twilight ethereal lighting, hyper-detailed textures, museum gallery editorial quality.",
    "imageUrl": "/styles/voxnela50/reality-warp.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "tactile-hyperrealism",
    "rank": 2,
    "title": "Tactile Hyperrealism / Texture Check",
    "badge": "Dokunsal 3D",
    "description": "Fotoğrafını dokunulabilir heykelsi materyallerle yeniden yaratır: oluklu buzlu cam, balmumu, silikon kıvrımlar ve PBR ışık.",
    "samplePrompt": "Beni buzlu cam ve heykelsi dokunsal silikon materyallerle çevrili şık bir portre yap",
    "realPrompt": "Tactile hyperrealism macro photography and editorial portrait. The subject sculpted and framed through ultra-detailed physical surfaces of frosted fluted glass refractions, molten beeswax droplets, organic ribbed silicone accents, brushed champagne metal, physical PBR caustic lighting, tactile micro-textures.",
    "imageUrl": "/styles/voxnela50/tactile-hyperrealism.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "retro-futurism",
    "rank": 3,
    "title": "Retro Futurism",
    "badge": "Space Age",
    "description": "Fotoğrafını 1970'ler ve 80'lerin uzay çağı hayaline ışınlar; CRT monitörler, krom kasklar ve analog bilim kurgu estetiği.",
    "samplePrompt": "Bizi retro uzay çağı astronot çifti olarak CRT ekranlı kokpitte göster",
    "realPrompt": "Authentic retro futurism 1970s-80s space age portrait photography. A stylish explorer in tailored retro-futuristic flight tailoring standing beside curved warm CRT monitors, glowing analog dials, and polished chrome spheres. Neon grid horizon in distance, warm analog film grain, pastel teal and apricot sunset sky, editorial cinematic magazine aesthetic.",
    "imageUrl": "/styles/voxnela50/retro-futurism.webp?v=2",
    "aspectRatio": "9:16"
  },
  {
    "id": "neo-minimalism",
    "rank": 4,
    "title": "Neo-Minimalism",
    "badge": "Sessiz Mimari",
    "description": "Fotoğrafını traverten monolitler, ham keten kumaşlar ve yumuşak doğal ışıkla minimalist bir sanat galerisi portresine dönüştürür.",
    "samplePrompt": "Beni traverten mimari sütunlar arasında sade ve şık keten kıyafetle göster",
    "realPrompt": "Neo-minimalist editorial portrait photography. A fashionable subject standing calmly in architectural space sculpted with warm travertine limestone monoliths. Vast elegant negative space, soft ambient natural sunlight and gentle shadows, tactile raw linen drape, organic stillness, museum grade gallery aesthetic.",
    "imageUrl": "/styles/voxnela50/neo-minimalism.webp?v=2",
    "aspectRatio": "9:16"
  },
  {
    "id": "analog-scrapbook",
    "rank": 5,
    "title": "Analog Scrapbook / Notes App Chic",
    "badge": "DIY Chic",
    "description": "Fotoğrafını el yazısı notlar, washi bantlar, preslenmiş yapraklar ve yırtık kâğıt katmanlarıyla nostaljik bir günlüğe yerleştirir.",
    "samplePrompt": "Bizi el yazısı notlar ve nostaljik bantlarla süslenmiş bir seyahat günlüğü kolajına dönüştür",
    "realPrompt": "Analog scrapbook chic mixed media collage portrait. A stylish editorial portrait integrated with layered deckle-edge photo prints, translucent washi tape strips, pressed botanical leaves, handwritten editorial notes and vintage diary paper textures. Warm nostalgic film tone, creative art direction.",
    "imageUrl": "/styles/voxnela50/analog-scrapbook.webp?v=2",
    "aspectRatio": "9:16"
  },
  {
    "id": "authentically-artificial",
    "rank": 7,
    "title": "Authentically Artificial",
    "badge": "AI Moda",
    "description": "Fotoğrafını kusursuz pastel akrilik yüzeyler ve heykelsi manken duruşuyla avangart bir stüdyo dioramasına dönüştürür.",
    "samplePrompt": "Beni pastel akrilik sütunlar üzerinde heykelsi bir podyum mankeni gibi konumlandır",
    "realPrompt": "Authentically artificial surrealist diorama portrait. A stylish subject posed like a high-fashion mannequin within hyper-smooth pastel architectural surfaces, unapologetic synthetic perfection, glossy acrylic plinths, uncanny hyper-clean composition, sophisticated conceptual art direction.",
    "imageUrl": "/styles/voxnela50/authentically-artificial.webp?v=2",
    "aspectRatio": "9:16"
  },
  {
    "id": "surreal-silliness",
    "rank": 8,
    "title": "Surreal Silliness",
    "badge": "Absürt Pop",
    "description": "Fotoğrafını yüksek moda zarafeti ve absürt mizahla birleştirir; buluttan el çantası, dev meyveler veya yerçekimsiz aksesuarlar.",
    "samplePrompt": "Beni devasa yumuşacık bir bulutu çanta gibi taşıyan şık bir haute couture karakter yap",
    "realPrompt": "High-concept surreal comedy fashion portrait. A stylish subject wearing an impeccably tailored haute couture outfit while carrying a giant floating, fluffy cloud like a handbag in a grand neoclassical hallway. Playful absurdism, high-end editorial lighting, crisp humorous elegance.",
    "imageUrl": "/styles/voxnela50/surreal-silliness.webp?v=2",
    "aspectRatio": "9:16"
  },
  {
    "id": "80s-ai-photography",
    "rank": 9,
    "title": "80s AI Photography",
    "badge": "80ler Stüdyo",
    "description": "Fotoğrafını 1980'lerin kabarık saçlı, vatkalı saten ceketli, yıldız filtreli ve soft-focus stüdyo portresine dönüştürür.",
    "samplePrompt": "Beni 80'lerin nostaljik Amerikan stüdyo fotoğrafına, vatkalı ceket ve soft-focus ışıkla ışınla",
    "realPrompt": "Authentic 1980s soft-focus studio portrait photography. A stylish subject with voluminous 80s hairstyle wearing a satin power blazer with shoulder pads. Warm diffused starburst lens flare, pastel pink and lavender backdrop, gentle analog halation, vintage 1980s magazine cover aesthetic.",
    "imageUrl": "/styles/voxnela50/80s-ai-photography.webp?v=2",
    "aspectRatio": "9:16"
  },
  {
    "id": "zine-risograph",
    "rank": 10,
    "title": "Zine / Xerox / Risograph",
    "badge": "Punk Print",
    "description": "Fotoğrafını iki renkli Riso mürekkebi (neon pembe ve sarı), tram noktaları ve ham geri dönüştürülmüş kâğıt dokusuna aktarır.",
    "samplePrompt": "Beni bağımsız müzik fanzini kapağında neon pembe ve sarı risograph baskı portre yap",
    "realPrompt": "Two-color authentic Risograph print portrait poster. Stylized portrait of an artistic subject printed with overlapping translucent fluorescent pink and deep sunflower yellow inks on textured rough fibrous recycled art paper. Halftone dot screen patterns, organic ink misregistration, brutalist indie zine cover typography.",
    "imageUrl": "/styles/voxnela50/zine-risograph.webp?v=2",
    "aspectRatio": "9:16"
  },
  {
    "id": "glitchy-glam",
    "rank": 11,
    "title": "Glitchy Glam",
    "badge": "Cyber Glam",
    "description": "Fotoğrafını metalik siber ceket, krom detaylar, RGB renk ayrışması ve lüks fütüristik gece atmosferine taşır.",
    "samplePrompt": "Beni metalik siber ceket giymiş, RGB glitch ışıklarıyla aydınlanan karizmatik bir model yap",
    "realPrompt": "Glitchy glam high-fashion editorial portrait. A charismatic subject with sharp sculpted facial features wearing an avant-garde metallic structured cyber jacket. Subtle RGB chromatic aberration split along edges, datamosh digital glitch artifacts, holographic lens flares, dark futuristic luxury setting.",
    "imageUrl": "/styles/voxnela50/glitchy-glam.webp?v=2",
    "aspectRatio": "9:16"
  },
  {
    "id": "neo-deco",
    "rank": 12,
    "title": "Neo Deco",
    "badge": "Lüks Deco",
    "description": "Fotoğrafını Art Deco mimarisi, pirinç geometrik kemerler, siyah mermer ve smokin/gece elbisesi zarafetine dönüştürür.",
    "samplePrompt": "Beni Art Deco pirinç kemerli bir salonda kusursuz siyah smokin/gece elbisesiyle göster",
    "realPrompt": "2026 Neo Deco architectural portrait. A distinguished subject in bespoke tailored midnight-black formal attire, standing in a grand symmetrical gallery of stepped geometric brass arches and polished black Nero Marquina marble. Champagne gold metallic reflections, opulent modern grandeur.",
    "imageUrl": "/styles/voxnela50/neo-deco.webp?v=2",
    "aspectRatio": "9:16"
  },
  {
    "id": "organic-flow",
    "rank": 13,
    "title": "Organic Flow",
    "badge": "Flow Portre",
    "description": "Fotoğrafını sıvı ipek dalgaları, Art Nouveau akışkan hatlar ve sıcak terakota-adaçayı tonlarında heykelsi bir portreye dönüştürür.",
    "samplePrompt": "Beni akışkan ipek kumaşlar ve yumuşak organik dalgalarla harmanlanan zarif bir portre yap",
    "realPrompt": "Organic flow fine art portrait photography. The subject elegantly enveloped in fluid undulating silk fabrics and sculptural topography curves, Art Nouveau organic contours blended with modern minimalism, warm earthy terracotta and sage gradient lighting, cinematic editorial depth.",
    "imageUrl": "/styles/voxnela50/organic-flow.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "liquid-glass",
    "rank": 14,
    "title": "Liquid Glass",
    "badge": "Cam & Işık",
    "description": "Fotoğrafını saydam cam refraksiyonları, prizmatik ışık kırılmaları ve sıvı cam dalgaları arkasından büyüleyici bir portreye dönüştürür.",
    "samplePrompt": "Beni kalın sıvı cam dalgaları ve optik ışık kırılmaları arkasından sanatsal bir portre olarak göster",
    "realPrompt": "Liquid glass fine art portrait photography. The subject's face and silhouette artistically viewed through thick transparent liquid glass waves, optical caustic light dispersion, rounded frosted glass refraction volumes, gentle distortion of facial contours, pristine studio illumination.",
    "imageUrl": "/styles/voxnela50/liquid-glass.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "chrome-liquid-metal",
    "rank": 15,
    "title": "Chrome / Liquid Metal",
    "badge": "Sıvı Krom",
    "description": "Fotoğrafını vücudu saran cıva damlaları, parlatılmış sıvı krom zırh ve koyu obsidyen arka planda fütüristik bir ikona dönüştürür.",
    "samplePrompt": "Beni omuzlarından sıvı cıva akan fütüristik krom zırhlı bir kahramana dönüştür",
    "realPrompt": "Futuristic liquid chrome high-fashion portrait. The subject styled with flowing mercurial molten chrome accents draping organically across the shoulders and neck, pristine mirror-gloss reflections of studio softboxes, sharp facial contours, deep obsidian contrast backdrop.",
    "imageUrl": "/styles/voxnela50/chrome-liquid-metal.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "iridescent-holographic",
    "rank": 16,
    "title": "Iridescent / Holographic",
    "badge": "Hologram",
    "description": "Fotoğrafını prizmatik inci ışıltısı, leylak-turkuaz geçişleri ve yarı saydam kristal ışık yansımalarıyla rüya gibi bir portreye çevirir.",
    "samplePrompt": "Beni inci parlaklığında prizmatik ışıklar ve leylak-turkuaz tonlarıyla parlayan bir portre yap",
    "realPrompt": "Iridescent holographic portrait photography. The subject bathed in shifting pearlized prismatic reflections, soft translucent gradients of lilac, cyan, and rose gold illuminating skin and minimalist tailoring, ethereal crystalline atmospheric glow.",
    "imageUrl": "/styles/voxnela50/iridescent-holographic.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "saturation-revival",
    "rank": 17,
    "title": "Saturation Revival",
    "badge": "Dopamin",
    "description": "Fotoğrafını elektrik kobalt mavisi ve neon gelincik kırmızısı gibi cesur kontrast renklerle yüksek enerjili bir moda çekimine dönüştürür.",
    "samplePrompt": "Beni kobalt mavisi ve alev kırmızısı renk bloklarıyla yüksek enerjili bir pop moda kapağı yap",
    "realPrompt": "Saturation revival color-blocking portrait photography. High-energy fashion portrait of the subject wearing sharp electric cobalt blue tailoring against a vibrant fluorescent poppy red studio cyclorama, punchy pop contrasts, razor-sharp studio flash, dopamine vibrancy.",
    "imageUrl": "/styles/voxnela50/saturation-revival.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "cool-blue-glacier",
    "rank": 18,
    "title": "Cool Blue / Glacier Aesthetic",
    "badge": "Buzul Portre",
    "description": "Fotoğrafını soğuk kutup mavisi stüdyo ışığı, donmuş cam dokuları ve kriyojenik buğu ile kristalize bir kış editoryaline taşır.",
    "samplePrompt": "Beni buz kristalleri ve donuk mavi stüdyo ışığında karizmatik bir kış editoryalinde göster",
    "realPrompt": "Cool blue glacier aesthetic portrait photography. The subject in crisp polar steel blue studio lighting, delicate crystalline frost textures framing the silhouette, cryogenic chilled glass atmosphere, serene high-contrast gaze, immaculate editorial styling.",
    "imageUrl": "/styles/voxnela50/cool-blue-glacier.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "blue-hour-cinematic",
    "rank": 19,
    "title": "Blue Hour Cinematic",
    "badge": "Mavi Saat",
    "description": "Fotoğrafını gün batımı sonrası lacivert alacakaranlık, sıcak sokak lambası yansımaları ve melankolik film tonlarına dönüştürür.",
    "samplePrompt": "Bizi gün batımı sonrası mavi saatte, şehrin sarı ışıkları altında yürüyen bir çift olarak göster",
    "realPrompt": "Cinematic blue hour dusk portrait photography. The subject captured at twilight under a deep indigo sky, warm amber streetlamp glow and distant city window reflections softly illuminating the face, delicate atmospheric mist, poignant 35mm cinema still.",
    "imageUrl": "/styles/voxnela50/blue-hour-cinematic.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "maximalist-chaos",
    "rank": 20,
    "title": "Maximalist Chaos / Anti-Design",
    "badge": "Anti-Design",
    "description": "Fotoğrafını çakışan tipografiler, sticker patlamaları, renkli bantlar ve isyankâr katmanlarla avangart bir sokak afişine dönüştürür.",
    "samplePrompt": "Beni stickerlar, çakışan neon fontlar ve sokak sanatı katmanlarıyla dolu kaotik bir poster yap",
    "realPrompt": "Maximalist chaos anti-design portrait poster. The subject's portrait immersed in wild overlapping graphic stickers, clashing experimental typography, saturated color spray bursts, torn xerox layers, and vibrant raw punk energy.",
    "imageUrl": "/styles/voxnela50/maximalist-chaos.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "brutalist-editorial",
    "rank": 21,
    "title": "Brutalist Editorial",
    "badge": "Brutalist",
    "description": "Fotoğrafını brüt beton mimari, sert geometrik gölgeler, yüksek kontrastlı siyah-beyaz ve monolitik bir güce büründürür.",
    "samplePrompt": "Beni brüt beton duvarlar önünde sert gölgeli, yüksek kontrastlı siyah-beyaz bir editoryal portre yap",
    "realPrompt": "Brutalist editorial portrait photography. High-contrast stark black and white portrait of the subject framed against monolithic raw poured concrete architecture, sharp geometric diagonal shadows, uncompromising avant-garde posture, Swiss magazine editorial layout.",
    "imageUrl": "/styles/voxnela50/brutalist-editorial.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "quiet-luxury-editorial",
    "rank": 22,
    "title": "Quiet Luxury Editorial",
    "badge": "Sessiz Lüks",
    "description": "Fotoğrafını sıcak kaşmir krem ve espresso tonları, saf ipek dokusu ve doğal pencere ışığıyla zamansız bir zarafete taşır.",
    "samplePrompt": "Beni krem kaşmir kazak ve doğal güneş ışığı alan minimalist bir odada sofistike bir portre olarak göster",
    "realPrompt": "Quiet luxury editorial portrait photography. The subject styled in bespoke rich cashmere knitwear and pure mulberry silk drape in warm cream and espresso tones, minimalist architectural interior, ample negative space, soft morning window light, understated prestige.",
    "imageUrl": "/styles/voxnela50/quiet-luxury-editorial.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "raw-documentary-realism",
    "rank": 23,
    "title": "Raw Documentary Realism",
    "badge": "Belgesel",
    "description": "Fotoğrafını yapay filtrelerden arındırır; doğal sabah ışığı, gerçek cilt dokusu ve samimi, plansız bir hayat anına dönüştürür.",
    "samplePrompt": "Beni sabah kahvesini içerken pencereden gelen doğal ışıkta, filtresiz ve samimi bir belgesel anı olarak göster",
    "realPrompt": "Raw documentary realism candid photograph. An unposed authentic moment of the subject illuminated by natural morning window light, realistic skin micro-textures and subtle expressions preserved, gentle optical 35mm grain, heartfelt observational photojournalism.",
    "imageUrl": "/styles/voxnela50/raw-documentary-realism.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "35mm-film-editorial",
    "rank": 24,
    "title": "35mm Film Editorial",
    "badge": "Portra 400",
    "description": "Fotoğrafını efsanevi Leica M6 ve Kodak Portra 400 film kimyasına aktarır; organik gren, sıcak ten renkleri ve altın saat ışıltısı.",
    "samplePrompt": "Bizi altın saat ışığında 35mm analog kamerayla çekilmiş, sıcak Portra renklerinde göster",
    "realPrompt": "Authentic 35mm film editorial portrait photography on Leica M6 with 50mm f/1.4 lens. Genuine Kodak Portra 400 color science, creamy organic film grain, soft halation around sun-kissed hair highlights, warm natural nostalgic skin tones, timeless cinema aesthetic.",
    "imageUrl": "/styles/voxnela50/35mm-film-editorial.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "disposable-camera",
    "rank": 25,
    "title": "Disposable Camera / Direct Flash",
    "badge": "90lar Flaş",
    "description": "Fotoğrafını 90'ların tek kullanımlık plastik makinesine ışınlar; sert dahili flaş, karanlık arka plan ve partinin samimi enerjisi.",
    "samplePrompt": "Bizi 90'lar ev partisinde tek kullanımlık flaşlı kamerayla çekilmiş gibi neşeli ve samimi göster",
    "realPrompt": "Authentic 1990s disposable camera party snapshot. The subject(s) captured with direct harsh Xenon flash falloff, deep pitch-black background, playful candid kinetic motion, authentic vintage color cast, subtle light leak in the frame corner.",
    "imageUrl": "/styles/voxnela50/disposable-camera.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "polaroid-memorycore",
    "rank": 26,
    "title": "Polaroid Memorycore",
    "badge": "Polaroid",
    "description": "Fotoğrafını orijinal beyaz çerçeveli vintage Polaroid karesine dönüştürür; soluk kimyasal renkler ve kurşun kalemle yazılmış tarih.",
    "samplePrompt": "Bizi sevgilimle nostaljik beyaz çerçeveli bir Polaroid fotoğrafına dönüştür, altında el yazısıyla tarih olsun",
    "realPrompt": "Original vintage Polaroid instant portrait photograph. Iconic white bottom frame border, gently faded chemical emulsion tones, soft nostalgic memorycore glow, handwritten date in pencil on the white frame margin, intimate heartfelt personal memory.",
    "imageUrl": "/styles/voxnela50/polaroid-memorycore.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "vhs-camcorder-90s",
    "rank": 27,
    "title": "VHS / Camcorder 90s",
    "badge": "VHS 1996",
    "description": "Fotoğrafını 1996 model Panasonic el kamerasının manyetik bant kaydına dönüştürür; tarama çizgileri ve yeşil zaman damgası.",
    "samplePrompt": "Bizi 1996 yılına ışınla, köşesinde yeşil tarih yazan nostaljik bir VHS kaset kaydı karesi yap",
    "realPrompt": "Authentic 1996 Panasonic VHS home video frame capture. The subject in vintage 1990s attire, analog magnetic tape tracking scanline artifacts, chromatic color bleed along vibrant edges, green OSD timestamp overlay in bottom corner \"JUL. 18 1996 06:45 PM\", warm fluorescent glow.",
    "imageUrl": "/styles/voxnela50/vhs-camcorder-90s.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "dreamcore",
    "rank": 28,
    "title": "Dreamcore",
    "badge": "Dreamcore",
    "description": "Fotoğrafını uçsuz bucaksız pastel tepeler, leylak gökyüzü ve tanıdık ama gerçek dışı nesnelerle çocukluk rüyanıza taşır.",
    "samplePrompt": "Beni leylak renkli gökyüzü ve sonsuz pastel tepeler arasında duran bir rüya kahramanı yap",
    "realPrompt": "Dreamcore nostalgic surreal portrait photography. The subject standing peacefully in an endless expanse of gentle pastel hills under a soft lilac sky, a lone mystical doorway standing in the open meadow, uncanny nostalgic childhood dreamscape atmosphere.",
    "imageUrl": "/styles/voxnela50/dreamcore.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "liminal-space",
    "rank": 29,
    "title": "Liminal Space",
    "badge": "Liminal",
    "description": "Fotoğrafını sonsuz koridorlar, yumuşak floresan ışığı ve sinematik bir içsel yolculuk atmosferine yerleştirir.",
    "samplePrompt": "Beni ıssız ve minimalist modern bir koridorda derin düşüncelere dalmış bir sinema karakteri yap",
    "realPrompt": "Cinematic liminal space portrait. The subject standing thoughtfully in an eerily calm, deserted modernist hallway with repeating doors and warm glowing overhead lights, soft perspective depth, cinematic psychological presence.",
    "imageUrl": "/styles/voxnela50/liminal-space.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "extra-celestial",
    "rank": 30,
    "title": "Extra Celestial",
    "badge": "Kozmik",
    "description": "Fotoğrafını yıldız tozu nebulaları, metalik gezegenler ve gümüşi yıldız ışığıyla parlayan bir uzay kaşifine dönüştürür.",
    "samplePrompt": "Beni parlayan yıldız nebulaları ve gümüş gezegenler arasında süzülen bir kozmik kaşif yap",
    "realPrompt": "Extra celestial deep space portrait. The subject reimagined as an ethereal star explorer surrounded by glowing cosmic nebula dust and mirror-smooth metallic planetary spheres, deep midnight navy and starry silver celestial radiance, cinematic sci-fi majesty.",
    "imageUrl": "/styles/voxnela50/extra-celestial.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "augmented-nature",
    "rank": 31,
    "title": "Augmented Nature / Bio-Digital",
    "badge": "Bio-Digital",
    "description": "Fotoğrafını biyolüminesans yapraklar, mavi ışık yayan damarlar ve doğa ile teknolojinin kaynaştığı fütüristik bir portreye çevirir.",
    "samplePrompt": "Beni karanlık bir ormanda mavi parlayan biyo-ışık damarları ve egzotik bitkilerle çevrili göster",
    "realPrompt": "Augmented nature bio-digital portrait. The subject intertwined with bioluminescent botanical flora, luminous cyan veins tracing natural deep emerald leaves, delicate glowing spore motes drifting in the air, organic future symbiosis.",
    "imageUrl": "/styles/voxnela50/augmented-nature.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "botanical-surrealism",
    "rank": 32,
    "title": "Botanical Surrealism",
    "badge": "Botanical",
    "description": "Fotoğrafını omuzlardan açan dev orkideler, sarmalanan asmalar ve altın polen tozlarıyla heykelsi bir doğa masalına dönüştürür.",
    "samplePrompt": "Beni kıyafetimden dev egzotik çiçeklerin filizlendiği sürrealist bir doğa portresine dönüştür",
    "realPrompt": "Botanical surrealism fine art portrait. Colossal sculptural exotic orchid petals and organic vine silhouettes blooming organically around the subject, floating golden pollen motes, dreamlike natural elegance, haute couture surrealism.",
    "imageUrl": "/styles/voxnela50/botanical-surrealism.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "soft-botanical",
    "rank": 33,
    "title": "Soft Botanical / Tender Naturalism",
    "badge": "Natüralizm",
    "description": "Fotoğrafını zeytin dalları arasından süzülen sabah güneşi, ham keten kumaş ve papatya motifleriyle dingin bir wellness portresine çevirir.",
    "samplePrompt": "Beni sabah güneşi ve okaliptüs yapraklarının gölgesinde dingin bir wellness portresi olarak göster",
    "realPrompt": "Soft botanical wellness portrait photography. Gentle morning sunbeams filtering through eucalyptus and wild chamomile onto the subject, soft natural shadows across skin and raw textured linen, calming organic wellness beauty aesthetic.",
    "imageUrl": "/styles/voxnela50/soft-botanical.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "kidult-toycore",
    "rank": 34,
    "title": "Kidult / Toycore",
    "badge": "Toycore",
    "description": "Fotoğrafını 80'ler-90'lar retro blister kutusu içinde koleksiyonluk bir aksiyon figürüne ve oyuncak bebeğe dönüştürür.",
    "samplePrompt": "Beni retro ambalajlı bir blister oyuncak kutusu içindeki koleksiyonluk aksiyon figürüne dönüştür",
    "realPrompt": "Kidult toycore collectible transformation. The subject transformed into a stylized designer vinyl action figure packaged inside an authentic 1980s retro toy blister pack with colorful illustrated cardboard backing, glossy bubble plastic cover, playful collectible finish.",
    "imageUrl": "/styles/voxnela50/kidult-toycore.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "plush-fuzzy-3d",
    "rank": 35,
    "title": "Plush / Fuzzy 3D",
    "badge": "Fuzzy 3D",
    "description": "Fotoğrafını yumuşacık kürklü, keçe dokulu, düğme gözlü ve kucaklanası sevimli bir 3D peluş oyuncağa dönüştürür.",
    "samplePrompt": "Beni ya da çocuğumu sıcacık pofuduk bir keçe peluş ayı / bebek karakterine dönüştür",
    "realPrompt": "Plush fuzzy 3D character transformation. The subject transformed into an adorable, touchable felted plush doll character with ultra-soft faux-fur textures, cozy knitted pastel sweater, warm ambient global illumination, irresistible soft charm.",
    "imageUrl": "/styles/voxnela50/plush-fuzzy-3d.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "inflatable-gummy-3d",
    "rank": 36,
    "title": "Inflatable / Gummy 3D",
    "badge": "Gummy 3D",
    "description": "Fotoğrafını parlak, yarı saydam meyveli jelibon malzemesi ve yuvarlatılmış şişme 3D pop karakterine dönüştürür.",
    "samplePrompt": "Beni parlayan yarı saydam meyve aromalı bir jelibon 3D karakterine çevir",
    "realPrompt": "Inflatable gummy 3D pop portrait. The subject reimagined as a glossy, translucent gummy candy 3D character with internal volumetric light scattering, bouncy rounded inflatable volumes, juicy pop colors, pristine studio reflections.",
    "imageUrl": "/styles/voxnela50/inflatable-gummy-3d.webp?v=3",
    "aspectRatio": "9:16"
  },
  {
    "id": "clay-soft-3d",
    "rank": 37,
    "title": "Clay / Soft 3D",
    "badge": "Clay 3D",
    "description": "Fotoğrafını Pixar ve Aardman tarzı, parmak izi kusurlarına sahip sevimli bir el yapımı hamur/kil animasyon karakterine dönüştürür.",
    "samplePrompt": "Çocuğumu (ya da beni) Wallace & Gromit tarzı sevimli bir el yapımı hamur animasyon figürüne dönüştür",
    "realPrompt": "Handcrafted claymation 3D character transformation. The subject transformed into an adorable stop-motion clay character (Aardman / Pixar clay style), tactile polymer clay texture with tiny realistic fingerprint imperfections, charming rounded facial features, warm soft studio clay lighting.",
    "imageUrl": "/styles/voxnela50/clay-soft-3d.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "miniature-diorama",
    "rank": 38,
    "title": "Miniature Diorama / Isometric 3D",
    "badge": "Diorama",
    "description": "Fotoğrafını 45° açılı minik bir izometrik odada yaşayan sevimli bir minyatür maket figürüne dönüştürür; tilt-shift derinlik hissi.",
    "samplePrompt": "Bizi sıcacık minyatür bir kitap odasında yaşayan sevimli 3D maket figürler olarak göster",
    "realPrompt": "Miniature isometric 3D diorama portrait. A charming tiny miniature figurine of the subject inside an exquisitely detailed, cozy miniature room at a 45-degree isometric angle, tilt-shift shallow depth of field, miniature warm lamp lighting, exquisite micro-craftsmanship.",
    "imageUrl": "/styles/voxnela50/miniature-diorama.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "papercut-layered",
    "rank": 39,
    "title": "Papercut / Layered Paper",
    "badge": "Papercut",
    "description": "Fotoğrafını lazer kesim renkli karton katmanları ve gölgelerle el işi 3D bir kâğıt kesim portreye dönüştürür.",
    "samplePrompt": "Beni renkli kâğıt katmanlarından kesilmiş gölgeli bir kâğıt rölyef portresi yap",
    "realPrompt": "Multi-layered papercut shadowbox artwork. The subject's portrait sculpted from intricate multi-layered laser-cut colored cardstock, realistic soft cast paper shadows creating deep 3D relief, tactile artisanal papercraft depth.",
    "imageUrl": "/styles/voxnela50/papercut-layered.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "textile-fiber-art",
    "rank": 40,
    "title": "Textile / Embroidery / Fiber Art",
    "badge": "Fiber Art",
    "description": "Fotoğrafını yün iplikler, bukle dokuma ve el yapımı nakış ilmekleriyle sıcak bir goblen tekstil portresine çevirir.",
    "samplePrompt": "Beni duvara asılan sıcak yün nakış ve dokuma bir goblen portresine dönüştür",
    "realPrompt": "Artisanal textile fiber art portrait tapestry. The subject's likeness woven into rich textured woolen embroidery loops, textured boucle yarn, handcrafted needlepoint stitches, warm natural folk craft aesthetic.",
    "imageUrl": "/styles/voxnela50/textile-fiber-art.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "hand-drawn-doodle",
    "rank": 41,
    "title": "Hand-Drawn Imperfect / Doodle",
    "badge": "Doodle",
    "description": "Fotoğrafını dinamik kurşun kalem çizgileri, eğlenceli el yazısı notlar ve karalama illüstrasyon tarzına aktarır.",
    "samplePrompt": "Beni eskiz defteri sayfasına çizilmiş dinamik kurşun kalem karalamaları ve sevimli detaylarla göster",
    "realPrompt": "Expressive hand-drawn doodle portrait. The subject sketched with energetic graphite pencil strokes, playful wavy contour lines, whimsical scribbles and hand-drawn annotations on textured cream sketchbook paper, soulful human touch.",
    "imageUrl": "/styles/voxnela50/hand-drawn-doodle.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "naive-folk",
    "rank": 42,
    "title": "Naïve Folk Illustration",
    "badge": "Folk Art",
    "description": "Fotoğrafını canlı halk sanatı renkleri, çiçek desenleri ve geleneksel guaj fırça darbeleriyle masalsı bir tabloya dönüştürür.",
    "samplePrompt": "Bizi masalsı köy çiçekleri ve geleneksel guaj boyalarla boyanmış bir halk sanatı tablosu yap",
    "realPrompt": "Naïve folk art portrait illustration. Handcrafted portrait of the subject painted in traditional gouache with bold flat earthy pigments, decorative floral patterns, simple folk perspective, handmade deckle paper texture.",
    "imageUrl": "/styles/voxnela50/naive-folk.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "heritage-remix",
    "rank": 43,
    "title": "Heritage Remix / Modern Folk",
    "badge": "Heritage",
    "description": "Fotoğrafını geleneksel Anadolu kilim geometrisi ve modern podyum modasının cesur renkleriyle buluşturur.",
    "samplePrompt": "Beni geleneksel Anadolu motifleriyle süslenmiş şık bir modern haute couture kıyafet içinde göster",
    "realPrompt": "Heritage remix contemporary portrait. The subject styled in modern high-fashion tailoring adorned with reimagined traditional Anatolian geometric kilim patterns, bold electric cobalt and vermilion accents, striking cultural fusion.",
    "imageUrl": "/styles/voxnela50/heritage-remix.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "pixel-retro-tech",
    "rank": 44,
    "title": "Pixel / Retro-Tech",
    "badge": "Pixel Art",
    "description": "Fotoğrafını 90'ların 16-bit konsol oyunlarındaki karizmatik bir RPG karakter sprite'ına ve CRT ekranına ışınlar.",
    "samplePrompt": "Beni 90'lar konsol oyunundaki bir RPG ana karakteri ve 16-bit piksel avatara dönüştür",
    "realPrompt": "Crisp 16-bit pixel art portrait. The subject transformed into a detailed 16-bit cyberpunk RPG game protagonist sprite, nostalgic retro dialogue window at bottom, sharp pixel grid resolution, warm CRT phosphor scanlines, vibrant 90s arcade colors.",
    "imageUrl": "/styles/voxnela50/pixel-retro-tech.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "ui-core",
    "rank": 45,
    "title": "Prompt Playground / UI-Core",
    "badge": "UI-Core",
    "description": "Fotoğrafını şeffaf arayüz pencereleri, terminal kod satırları ve fütüristik HUD göstergeleriyle hacker/geliştirici estetiğine büründürür.",
    "samplePrompt": "Beni kod satırları ve şeffaf HUD arayüz pencereleriyle çevrili bir siber güvenlik uzmanı yap",
    "realPrompt": "UI-core cyber developer portrait. The subject framed by sleek minimalist code syntax overlays, glowing monospace prompt cursors, translucent floating HUD dialogue windows, subtle blueprint alignment guides, sleek dark-mode aesthetic.",
    "imageUrl": "/styles/voxnela50/ui-core.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "data-core-infographic",
    "rank": 46,
    "title": "Data-Core / Infographic Collage",
    "badge": "Data-Core",
    "description": "Fotoğrafını teknik telemetri vektörleri, koordinat ızgaraları ve fütüristik analiz şemalarıyla siber bir ajana dönüştürür.",
    "samplePrompt": "Beni siber telemetri analizleri ve mavi teknik şemalarla taranan bir ajan portresi yap",
    "realPrompt": "Data-core technical infographic portrait. The subject's portrait integrated with high-density cyan vector telemetry schematics, biometric scan coordinate data, architectural wireframe overlays on a deep slate grid, high-tech intelligence aesthetic.",
    "imageUrl": "/styles/voxnela50/data-core-infographic.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "anime-cinematic",
    "rank": 47,
    "title": "Anime Cinematic",
    "badge": "Shinkai Anime",
    "description": "Fotoğrafını Makoto Shinkai tarzı görkemli gün batımı bulutları, güneş ışığı huzmeleri ve anime filmi başrolüne dönüştürür.",
    "samplePrompt": "Beni gün batımında rüzgarlı bir tepede devasa Shinkai bulutları altında bir anime başrolü yap",
    "realPrompt": "Cinematic anime hero portrait. The subject transformed into a breathtaking Makoto Shinkai style anime film protagonist, standing on a wind-swept green hill under towering golden hour cumulus clouds and shimmering volumetric sunbeam shafts, emotional cinematic masterpiece.",
    "imageUrl": "/styles/voxnela50/anime-cinematic.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "painterly-anime",
    "rank": 48,
    "title": "Painterly Anime / Nostalgic Animation",
    "badge": "Ghibli Stili",
    "description": "Fotoğrafını Studio Ghibli tarzı el boyaması suluboya kır çiçekleri, yumuşak esinti ve sıcacık nostaljik bir animasyon karesine dönüştürür.",
    "samplePrompt": "Bizi Studio Ghibli tarzı el boyaması suluboya bir kır manzarası içinde nostaljik anime karakterleri yap",
    "realPrompt": "Painterly Ghibli anime portrait. The subject transformed into a nostalgic Studio Ghibli character, hand-painted watercolor and gouache textures, gentle summer breeze rustling hair, soft pastoral wildflower meadow background, warm heartwarming nostalgia.",
    "imageUrl": "/styles/voxnela50/painterly-anime.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "high-fashion-surreal",
    "rank": 49,
    "title": "High-Fashion Surreal Editorial",
    "badge": "Haute Surreal",
    "description": "Fotoğrafını mimari brütalist çöl heykelleri arasında heykelsi bir haute couture elbise ve ring flaşla podyum efsanesine taşır.",
    "samplePrompt": "Beni brütalist çöl heykelleri arasında heykelsi avangart bir elbiseyle yüksek moda kapağı yap",
    "realPrompt": "High-fashion surreal editorial portrait. The subject transformed into a statuesque haute couture icon wearing a sculptural avant-garde couture gown, posed dramatically within an impossible brutalist desert amphitheater, direct ring flash, ultra-striking fine art fashion.",
    "imageUrl": "/styles/voxnela50/high-fashion-surreal.webp",
    "aspectRatio": "9:16"
  },
  {
    "id": "hyperreal-product-cgi",
    "rank": 50,
    "title": "Hyperreal Product CGI",
    "badge": "Kampanya Yüzü",
    "description": "Fotoğrafını lüks bir parfüm veya kozmetik markasının dünya çapındaki kampanya yüzü olarak kusursuz stüdyo ışıltısına dönüştürür.",
    "samplePrompt": "Beni lüks bir mücevher ve parfüm markasının dünya çapındaki global reklam yüzü yap",
    "realPrompt": "Hyperreal luxury commercial campaign portrait. The subject transformed into the prestigious face of a high-end luxury campaign, interacting with crystalline water ripples, faceted levitating perfume glass flacons, pristine caustic reflections, flawless commercial studio lighting.",
    "imageUrl": "/styles/voxnela50/hyperreal-product-cgi.webp",
    "aspectRatio": "9:16"
  }
];

export const VOXNELA_50_STYLE_SUGGESTIONS: Record<string, [string, string]> = {
  "reality-warp": [
    "Kendi veya sevgilinin fotoğrafını yerçekimsiz süzülen rüya mimarisinde göster.",
    "Bükülmüş perspektif ve alacakaranlık tonlarıyla sürreal bir galeri portresi oluştur."
  ],
  "tactile-hyperrealism": [
    "Portreni oluklu buzlu cam ve balmumu damlacıkları arkasında heykelsi bir kompozisyona çevir.",
    "Dokunsal silikon kıvrımlar ve şampanya metal ışıltısıyla 3D derinlik kat."
  ],
  "retro-futurism": [
    "Kendini 1970'lerin uzay çağı astronotu olarak CRT ekranlı analog kokpitte konumlandır.",
    "Krom kask, neon ufuk çizgisi ve sıcak analog film greniyle nostaljik bilim kurgu havası ver."
  ],
  "neo-minimalism": [
    "Doğal portreni traverten taş bloklar ve ham keten kumaşlarla sessiz lüks havasına taşı.",
    "Geniş negatif alan ve yumuşak pencere gölgeleriyle minimalist galeri estetiği yarat."
  ],
  "analog-scrapbook": [
    "Fotoğrafını el yazısı notlar ve washi bantlarla süslenmiş bir seyahat günlüğü kapağına dönüştür.",
    "Preslenmiş botanik yapraklar ve yırtık kâğıt katmanlarıyla vintage kolaj oluştur."
  ],
  "authentically-artificial": [
    "Portreni pürüzsüz pastel akrilik sütunlar üzerinde avangart bir podyum mankeni gibi stilize et.",
    "Kusursuz sentetik stüdyo aydınlatması ve heykelsi duruşla yapay zeka modası yarat."
  ],
  "surreal-silliness": [
    "Haute couture kıyafetinle devasa yumuşacık bir bulutu çanta gibi taşıdığın absürt bir sahne kur.",
    "Neoklasik salonda yerçekimsiz uçuşan nesnelerle eğlenceli ve sıra dışı bir lüks portre üret."
  ],
  "80s-ai-photography": [
    "Kendini vatkalı saten ceket, hacimli saçlar ve yıldız filtresiyle 1980'ler retro stüdyo portresi yap.",
    "Pastel fon ve soft-focus ışıkla nostaljik Amerikan lise yıllığı veya dergi kapağı yakala."
  ],
  "zine-risograph": [
    "Fotoğrafını neon pembe ve ayçiçeği sarısı iki renkli Riso fanzin afişine aktar.",
    "Tram noktaları ve ham geri dönüştürülmüş kâğıt dokusuyla bağımsız müzik kapağı havası ver."
  ],
  "glitchy-glam": [
    "Kendini metalik siber ceket giymiş, RGB renk ayrışmasıyla parlayan fütüristik bir model yap.",
    "Holografik lens yansımaları ve karanlık lüks gece atmosferiyle siberpunk cazibesi yakala."
  ],
  "neo-deco": [
    "Fotoğrafını siyah smokin veya gece elbisesiyle Art Deco pirinç kemerli bir salona taşı.",
    "Geometrik kemerler ve siyah mermer zeminle 2026 Neo-Deco ihtişamı yakala."
  ],
  "organic-flow": [
    "Portreni terakota ve adaçayı rengi akışkan ipek dalgalarıyla heykelsi bir sanat eserine çevir.",
    "Art Nouveau kıvrımları ve yumuşak stüdyo ışığıyla bedeni saran zarafet oluştur."
  ],
  "liquid-glass": [
    "Yüzünü kalın saydam cam dalgaları ve prizmatik optik kırılmalar arkasından göster.",
    "Kavisli cam refraksiyonları ve kostik ışık oyunlarıyla sanatsal soyut derinlik yakala."
  ],
  "chrome-liquid-metal": [
    "Omuzlarından sıvı cıva akan parlatılmış fütüristik bir krom zırh portresi oluştur.",
    "Koyu obsidyen arka plan ve kusursuz ayna yansımalarıyla güçlü bir siber ikon ol."
  ],
  "iridescent-holographic": [
    "Portreni leylak, camgöbeği ve gül altın prizmatik sedef ışıltısıyla kapla.",
    "Yarı saydam kristal ışık yansımalarıyla rüya gibi bir pastel moda çekimi yakala."
  ],
  "saturation-revival": [
    "Kendini kobalt mavisi şık bir takım elbiseyle gelincik kırmızısı stüdyo fonuna yerleştir.",
    "Jilet gibi stüdyo flaşı ve cesur renk bloklarıyla yüksek enerjili pop kapağı yap."
  ],
  "cool-blue-glacier": [
    "Fotoğrafını kutup mavisi stüdyo ışığı ve donmuş buz kristalleriyle kış editoryaline taşı.",
    "Kriyojenik buğu ve yüksek kontrastlı bakışlarla kristalize bir atmosfer yakala."
  ],
  "blue-hour-cinematic": [
    "Bizi veya kendini gün batımı sonrası lacivert alacakaranlıkta şehir ışıkları altında göster.",
    "Sıcak sokak lambası yansımaları ve 35mm film sinematografisiyle romantik bir an yakala."
  ],
  "maximalist-chaos": [
    "Portreni sticker patlamaları, çakışan neon tipografiler ve sprey boyalarla donat.",
    "Yırtık afiş katmanları ve çiğ punk enerjisiyle kuralsız bir sokak sanatı posteri üret."
  ],
  "brutalist-editorial": [
    "Kendini brüt dökme beton mimari sütunlar önünde sert gölgeli siyah-beyaz bir editoryale yerleştir.",
    "İsviçre dergi mizanpajı ve monolitik minimalizmle güçlü bir duruş sergile."
  ],
  "quiet-luxury-editorial": [
    "Fotoğrafını krem kaşmir kazak ve doğal sabah pencere ışığında sessiz lüks zarafetine taşı.",
    "Geniş negatif alan ve saf dut ipeği dökümleriyle abartısız bir prestij yakala."
  ],
  "raw-documentary-realism": [
    "Portreni filtresiz, gerçek cilt dokusu ve sabah kahvesi anıyla doğal bir belgesel karesi yap.",
    "Doğal pencere ışığı ve hafif 35mm greniyle samimi, plansız bir hayat hikâyesi anlat."
  ],
  "35mm-film-editorial": [
    "Kendini Leica M6 ve Kodak Portra 400 analog film tonlarıyla altın saat ışığında göster.",
    "Sıcak organik gren ve saçlarda güneş halesiyle zamansız bir sinema estetiği yakala."
  ],
  "disposable-camera": [
    "Arkadaşlarınla veya sevgilinle 90'lar ev partisinde tek kullanımlık flaşlı snapshot oluştur.",
    "Sert doğrudan flaş ve karanlık arka planla nostaljik, plansız bir gençlik anı yakala."
  ],
  "polaroid-memorycore": [
    "Fotoğrafını beyaz çerçeveli ikonik bir vintage Polaroid karesine dönüştür.",
    "Alt kenarına kurşun kalemle yazılmış nostaljik tarih ve soluk kimyasal tonlar ekle."
  ],
  "vhs-camcorder-90s": [
    "Kendini 1996 Panasonic el kamerası kaydında köşe zaman damgasıyla 90'lara ışınla.",
    "Bant parazitleri, hafif renk taşması ve yeşil OSD tarih yazısıyla nostaljik video karesi üret."
  ],
  "dreamcore": [
    "Fotoğrafını leylak gökyüzü altındaki sonsuz pastel tepelere ve rüya kapısına taşı.",
    "Çocukluk rüyalarını anımsatan nostaljik ve huzurlu bir sürreal dünya yarat."
  ],
  "liminal-space": [
    "Kendini minimalist ıssız bir modern mimari koridorda derin düşüncelere dalmış olarak konumlandır.",
    "Sıcak tavan lambaları ve tekrarlayan kapılarla sinematik psikolojik derinlik oluştur."
  ],
  "extra-celestial": [
    "Kendini yıldız tozu nebulaları ve gümüş gezegenler arasında süzülen bir kozmik kaşif yap.",
    "Derin gece mavisi ve parıldayan yıldız ışığıyla epik bir uzay portresi oluştur."
  ],
  "augmented-nature": [
    "Portreni karanlıkta mavi parlayan biyo-ışık yaprakları ve egzotik sarmaşıklarla birleştir.",
    "Doğa ve dijital teknolojinin kaynaştığı fütüristik bir biyo-hacker atmosferi yarat."
  ],
  "botanical-surrealism": [
    "Kıyafetinden ve omuzlarından dev orkideler filizlenen heykelsi bir doğa portresi oluştur.",
    "Havada süzülen altın polen tozları ve rüya gibi çiçeklerle avangart haute couture yakala."
  ],
  "soft-botanical": [
    "Portreni okaliptüs ve papatyalar arasından süzülen sabah güneşiyle aydınlat.",
    "Ham keten kumaş ve dingin doğal gölgelerle organik bir wellness portresi yarat."
  ],
  "kidult-toycore": [
    "Kendini 80'ler retro karton ambalajlı koleksiyonluk bir aksiyon figürüne dönüştür.",
    "Şeffaf plastik blister kutusu ve renkli illüstrasyon kartıyla nostaljik oyuncak üret."
  ],
  "plush-fuzzy-3d": [
    "Kendini veya çocuğunu yumuşacık keçe kürklü sevimli bir 3D peluş oyuncağa çevir.",
    "Örgü pastel kazak ve kucaklanası sıcak ışıkla büyüleyici bir peluş figür yap."
  ],
  "inflatable-gummy-3d": [
    "Fotoğrafını parlak, yarı saydam meyve aromalı bir jelibon 3D pop karakterine dönüştür.",
    "Şişme yumuşak hatlar ve canlı şeker renkleriyle eğlenceli 3D avatar oluştur."
  ],
  "clay-soft-3d": [
    "Kendini veya aileni Wallace & Gromit / Pixar tarzı sevimli bir hamur figüre çevir.",
    "Polimer kil dokusu ve minik parmak izi kusurlarıyla sıcacık bir stop-motion karakteri yarat."
  ],
  "miniature-diorama": [
    "Kendini 45 derece izometrik minyatür bir kitap odasında yaşayan sevimli bir maket figür yap.",
    "Tilt-shift sığ odak derinliği ve sıcak masa lambasıyla mikro dünya inşa et."
  ],
  "papercut-layered": [
    "Fotoğrafını renkli lazer kesim karton katmanlarından oluşan 3D kâğıt rölyefe dönüştür.",
    "Katmanlar arası derin kâğıt gölgeleriyle el yapımı heykelsi bir sanat eseri oluştur."
  ],
  "textile-fiber-art": [
    "Portreni duvara asılan sıcak yün dokuma ve el yapımı nakış ilmeklerine aktar.",
    "Bukle iplik ve goblen dokusuyla nostaljik bir el sanatları tablosu yap."
  ],
  "hand-drawn-doodle": [
    "Fotoğrafını dinamik kurşun kalem çizgileri ve sevimli el çizimi notlarla eskiz kâğıdına aktar.",
    "Spontane karalamalar ve dalgalı konturlarla samimi bir el yapımı çizim oluştur."
  ],
  "naive-folk": [
    "Kendini veya aileni geleneksel guaj boyalar ve kır çiçekleriyle masalsı bir halk sanatı tablosu yap.",
    "Toprak tonu pigmentler ve el yapımı kâğıt dokusuyla naif bir masal atmosferi yarat."
  ],
  "heritage-remix": [
    "Modern şık kıyafetini geleneksel Anadolu kilim geometrisi ve cesur renklerle harmanla.",
    "Kobalt mavisi ve alev kırmızısı desenlerle kültürel bir podyum füzyonu yarat."
  ],
  "pixel-retro-tech": [
    "Fotoğrafını 90'lar 16-bit RPG konsol oyunundaki karizmatik bir başrol sprite'ına dönüştür.",
    "Altta retro diyalog kutusu ve CRT fosfor tarama çizgileriyle piksel avatar oluştur."
  ],
  "ui-core": [
    "Portreni şeffaf HUD göstergeleri, terminal kod satırları ve yanıp sönen imleçlerle kuşat.",
    "Teknik siber güvenlik kılavuzları ve koyu tema estetiğiyle fütüristik hacker portresi yap."
  ],
  "data-core-infographic": [
    "Fotoğrafını biyometrik tarama koordinatları ve camgöbeği telemetri şemalarıyla analiz edilen bir ajan yap.",
    "Yüksek yoğunluklu teknik ızgara ve telkafes katmanlarıyla siber istihbarat havası kat."
  ],
  "anime-cinematic": [
    "Kendini Makoto Shinkai tarzı dev gün batımı bulutları altında rüzgarlı bir tepeye yerleştir.",
    "Işık huzmeleri ve parıldayan gökyüzüyle epik bir anime filmi başrolü portresi yakala."
  ],
  "painterly-anime": [
    "Bizi veya kendini Studio Ghibli tarzı el boyaması suluboya kır çiçekleri arasında göster.",
    "Yumuşak yaz esintisi ve nostaljik pastoral renklerle sıcacık bir anime karesi üret."
  ],
  "high-fashion-surreal": [
    "Fotoğrafını brütalist çöl heykelleri arasında heykelsi bir haute couture kıyafete büründür.",
    "Ring flaş ve avangart podyum duruşuyla uluslararası yüksek moda kapağı oluştur."
  ],
  "hyperreal-product-cgi": [
    "Kendini lüks parfüm veya mücevher markasının global kampanya yüzü olarak konumlandır.",
    "Süzülen kristal su damlaları ve kusursuz ticari stüdyo ışıltısıyla prestijli bir reklam portresi üret."
  ]
};

// Automatically populate suggestions into VOXNELA_50_STYLES
VOXNELA_50_STYLES.forEach((item) => {
  if (!item.suggestions && VOXNELA_50_STYLE_SUGGESTIONS[item.id]) {
    item.suggestions = VOXNELA_50_STYLE_SUGGESTIONS[item.id];
  }
});

export function getStyleSuggestions(
  idOrStyle: string | { id: string; suggestions?: [string, string] }
): [string, string] {
  if (typeof idOrStyle === "object" && idOrStyle?.suggestions && idOrStyle.suggestions.length >= 2) {
    return idOrStyle.suggestions;
  }
  const id = typeof idOrStyle === "string" ? idOrStyle : idOrStyle?.id;
  if (id && VOXNELA_50_STYLE_SUGGESTIONS[id]) {
    return VOXNELA_50_STYLE_SUGGESTIONS[id];
  }
  return [
    "Fotoğrafını bu stilin benzersiz görsel atmosferine dönüştür.",
    "Özel komutlar ve ışık detayları ekleyerek sanatsal bir portre elde et."
  ];
}
